
      import { onCLS, onLCP, onINP, onTTFB, onFCP } from 'https://unpkg.com/web-vitals@4/dist/web-vitals.attribution.js';
      const ENDPOINT = 'https://api.escortfun.net/vw/index.php';
      function sendToBackend(metric) {
        const payload = {
          name: metric.name,
          value: metric.value,
          rating: metric.rating,
          delta: metric.delta,
          url: location.href,
          timestamp: Date.now(),
          attribution: metric.attribution ?? null,
        };
        if (metric.name === 'CLS' && metric.attribution) {
          payload.largestShiftTarget = metric.attribution.largestShiftTarget;
        }
        navigator.sendBeacon(ENDPOINT, JSON.stringify(payload));
      }
      onCLS(sendToBackend);
      onLCP(sendToBackend);
      onINP(sendToBackend);
      onTTFB(sendToBackend);
      onFCP(sendToBackend);
    